/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface TeamData
 *
 */
// create custom validators for the regexes
typia.customValidators.insert("pattern_TeamData_id")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
export interface TeamData {
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof TeamData
        
        
    * @pattern_TeamData_id
         */
    id: string;
    /**
     *
     * #type string
     * #memberof TeamData
        
        
         */
    name: string;
    /**
     * unix timestamp in milliseconds
     * #type number
     * #memberof TeamData
        
    * @minimum 0
            
         */
    createdAt: number;
    /**
     * unix timestamp in milliseconds
     * #type number
     * #memberof TeamData
        
    * @minimum 0
            
         */
    validUntil: number;
}
/**
 * Check if a given object implements the TeamData interface.
 */
export function instanceOfTeamData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "validUntil" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const TeamDataTypiaAssertEquals = (input: any) => {
    return ((input: any): TeamData => {
        const __is = (input: any, _exceptionable: boolean = true): input is TeamData => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.id && $is_custom("pattern_TeamData_id", "string", "", input.id) && "string" === typeof input.name && ("number" === typeof input.createdAt && 0 <= input.createdAt) && ("number" === typeof input.validUntil && 0 <= input.validUntil) && (4 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["id", "name", "createdAt", "validUntil"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is TeamData => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_TeamData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_TeamData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && ("number" === typeof input.createdAt && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number",
                    value: input.createdAt
                })) && ("number" === typeof input.validUntil && (0 <= input.validUntil || $guard(_exceptionable, {
                    path: _path + ".validUntil",
                    expected: "number (@minimum 0)",
                    value: input.validUntil
                })) || $guard(_exceptionable, {
                    path: _path + ".validUntil",
                    expected: "number",
                    value: input.validUntil
                })) && (4 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["id", "name", "createdAt", "validUntil"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "TeamData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "TeamData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const TeamDataTypiaAssertStringify = (input: TeamData): string => {
    return ((input: any): string => { const assert = (input: any): TeamData => {
        const __is = (input: any): input is TeamData => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).id && $is_custom("pattern_TeamData_id", "string", "", (input as any).id) && "string" === typeof (input as any).name && ("number" === typeof (input as any).createdAt && !Number.isNaN((input as any).createdAt) && 0 <= (input as any).createdAt) && ("number" === typeof (input as any).validUntil && !Number.isNaN((input as any).validUntil) && 0 <= (input as any).validUntil));
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is TeamData => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_TeamData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_TeamData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && ("number" === typeof input.createdAt && !Number.isNaN(input.createdAt) && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number",
                    value: input.createdAt
                })) && ("number" === typeof input.validUntil && !Number.isNaN(input.validUntil) && (0 <= input.validUntil || $guard(_exceptionable, {
                    path: _path + ".validUntil",
                    expected: "number (@minimum 0)",
                    value: input.validUntil
                })) || $guard(_exceptionable, {
                    path: _path + ".validUntil",
                    expected: "number",
                    value: input.validUntil
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "TeamData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "TeamData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: TeamData): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        return `{"id":${$string((input as any).id)},"name":${$string((input as any).name)},"createdAt":${(input as any).createdAt},"validUntil":${(input as any).validUntil}}`;
    }; return stringify(assert(input)); })(input);
};
export const TeamDataValidatorShape = {
    'id': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'name': yup.string().defined(),
    'createdAt': yup.number().min(0).defined(),
    'validUntil': yup.number().min(0).defined(),
};
export const TeamDataValidator = yup.object().shape(TeamDataValidatorShape);
export const TeamDataStringifyShapeProperties: ObjectSchema['properties'] = {
    'id': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'name': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'createdAt': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
    'validUntil': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
};
export const TeamDataStringifyShape: ObjectSchema = {
    title: 'TeamData Stringifier',
    type: 'object',
    properties: {
        ...TeamDataStringifyShapeProperties
    },
    required: [
        'id',
        'name',
        'createdAt',
        'validUntil',
    ],
};
export const TeamDataStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(TeamDataStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const TeamDataStringify: (data: TeamData) => string = TeamDataStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function TeamDataFromJSON(json: any): TeamData {
    return TeamDataFromJSONTyped(json, false);
}
export function TeamDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'id': json['id'],
        'name': json['name'],
        'createdAt': json['createdAt'],
        'validUntil': json['validUntil'],
    };
}
export function TeamDataToJSON(value?: TeamData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'createdAt': value.createdAt,
        'validUntil': value.validUntil,
    };
}
